import { returnsDefaultWeightByZoneSchema } from "@redotech/redo-model/rate-table/rate-table";
import * as z from "zod/v4";

export const getDefaultRateTables = {
  name: "getDefaultRateTables" as const,
  input: z.object({}),
  output: z.object({ rateTables: z.array(returnsDefaultWeightByZoneSchema) }),
};
